import script from "./RestablecerContrasenaView.vue?vue&type=script&setup=true&lang=ts"
export * from "./RestablecerContrasenaView.vue?vue&type=script&setup=true&lang=ts"

import "./RestablecerContrasenaView.vue?vue&type=style&index=0&id=3758fbd6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3758fbd6"]])

export default __exports__